<template>
    <div>
        <transition name="slide-right-panel">
            <div class="side-panel right-sidebar shw-rside" v-show="show">
                <div class="rpanel-title">
                    {{ title }} <span><i class="icon mdi mdi-close right-side-toggle"
                                         @click="closePhotosPanel"></i></span>
                </div>
                <vue-dropzone id="photo-list-dropzone"
                              class="transition ease-in-out duration-100 border-2 border-dashed border-white"
                              ref="photolistDropzone"
                              :options="dropzoneOptions"
                              :use-custom-slot=true
                              :include-styling="false"
                              @vdropzone-drag-over="dragOver"
                              @vdropzone-drag-leave="dragLeave"
                              @vdropzone-drop="fileDropped"
                              @vdropzone-error="beforePhotoUpload"
                              @vdropzone-success="fileUploaded"
                              @vdropzone-upload-progress="processingFileUpload"
                              @vdropzone-complete="fileUploadCompletedOrFailed">
                    <div class="slimscrollright" id="container">
                        <div>
                            <div class="r-panel-body mb-5 custom-photo-list">
                                <ul class="el-upload-list el-upload-list--picture-card">
                                    <li v-for="photo in photos"
                                        :key="photo.id"
                                        tabindex="0" class="el-upload-list__item is-success">
                                        <img :src="photo.url_thumb_md"
                                             alt="" class="el-upload-list__item-thumbnail">
                                        <i v-if="isCopiedPhoto(photo)" class="copied-photo mdi mdi-content-copy"></i>
                                        <a class="el-upload-list__item-name">
                                            <i class="el-icon-document"></i>
                                            {{ photo.name }}
                                        </a>
                                        <i class="el-icon-close"></i>
                                        <i class="el-icon-close-tip">press delete to remove</i>
                                        <span class="el-upload-list__item-actions">
                                            <span class="el-upload-list__item-preview">
                                                <i @click.prevent="viewPhoto(photo)" class="el-icon-zoom-in"></i>
                                            </span>
                                            <span class="el-upload-list__item-delete">
                                                <i @click.prevent="removePhoto(photo)" class="el-icon-delete"></i>
                                            </span>
                                        </span>
                                    </li>
                                </ul>

                                <div style="margin-bottom:200px;">
                                    <transition
                                        enter-to-class="opacity-100"
                                        leave-class="opacity-100"
                                        enter-active-class="transition duration-1000 ease-in"
                                        leave-active-class="transition duration-1000 ease-in"
                                        enter-class="opacity-0"
                                        leave-to-class="opacity-0">
                                        <div v-if="processingUpload" class="flex-col h-8 w-full">
                                            <div class="flex justify-between">
                                                <span>
                                                    {{ fileName }}
                                                </span>
                                                <span>
                                                    {{ processingPercentage }}%
                                                </span>
                                            </div>
                                            <div class="border-b-2 border-blue-500" :style="'width:' + processingPercentage +'%'">
                                            </div>
                                        </div>
                                    </transition>
                                    <el-upload
                                        ref="elUpload"
                                        :action="photoUploadUrl"
                                        :headers="photoUploadRequestHeaders"
                                        :on-success="handlePhotoUploadSuccess"
                                        :on-error="handlePhotoUploadError"
                                        :before-upload="beforePhotoUpload"
                                        :on-preview="viewPhoto"
                                        :on-change="handleChange"
                                        :before-remove="removePhoto"
                                        list-type="picture-card"
                                        multiple>
                                        <i class="el-icon-plus"></i>
                                    </el-upload>
                                </div>
                            </div>
                        </div>
                    </div>
                </vue-dropzone>
            </div>
        </transition>

        <template v-if="hasFeature('feat_image_viewer')">
            <image-viewer-modal :images="lightboxImageUrls" v-if="showImageViewer" :show="showImageViewer" @close="toggleImageViewer()"
                                :selected-index="selectedImageIndex"></image-viewer-modal>
        </template>
        <template v-else>
            <lightbox :images="lightboxImageUrls" :width="500" :height="500"></lightbox>
        </template>
    </div>
</template>

<script>
import DropzoneOptions from "../../mixins/dropzone-options";

export default {
    mixins: [DropzoneOptions],
    props: ["fetchUrl", "uploadUrl", "title", "show", "modelId", "modelType"],

    data () {
        return {
            photos: [],
            photoUploadUrl: this.uploadUrl,
            photoUploadRequestHeaders: window.axios.defaults.headers.common,
            showImageViewer: false,
            selectedImageIndex: null,
        };
    },

    watch: {
        fetchUrl: function (newValue) {
            this.fetchPhotos();
        },

        uploadUrl: function (newValue) {
            this.photoUploadUrl = newValue;
        },

        photos: function () {
            this.setupScroll();
        },
    },

    computed: {
        lightboxImageUrls () {
            return this.photos.map(a => a.url);
        }
    },

    mounted () {
        this.setupScroll();
        this.fetchPhotos();
    },

    methods: {
        toggleImageViewer () {
            this.showImageViewer = !this.showImageViewer;

            if (!this.showImageViewer) {
                this.selectedImageIndex = null;
            }
        },

        setupScroll () {
            $(".slimscrollright").slimScroll({
                height: "100%",
                position: "right",
                size: "5px",
                color: "#dcdcdc"
            });
        },

        /**
         * Check if the photo was copied from another
         * instance based on the origin uuid being defined
         */
        isCopiedPhoto (photo) {
            return photo.custom_properties && !_.isEmpty(photo.custom_properties.origin_photo_uuid) && photo.custom_properties.origin_photo_uuid !== photo.uuid;
        },

        fetchPhotos () {

            if (_.isEmpty(this.fetchUrl)) {
                return;
            }

            if (this.$refs.elUpload) {
                this.$refs.elUpload.uploadFiles = [];
            }

            axios.get(this.fetchUrl)
            .then(response => {
                this.photos = response.data;
            });

        },

        handlePhotoUploadSuccess (response, file, fileList) {

            if (this.photos.length === 0) {
                Bus.$emit("first-photo-uploaded", file.url);
            }

            if (this.modelType === "tickets") {
                Bus.$emit("issues-updated");
            }

            if (this.$refs.elUpload) {
                let index = this.$refs.elUpload.uploadFiles.indexOf(file);
                this.$refs.elUpload.uploadFiles.splice(index, 1);
            }

        },

        handlePhotoUploadError (error, file, fileList) {
            toastr.error("Photo upload failed! Please try again.");
        },

        beforePhotoUpload (file, message, xhr) {
            const isImg = ["image/jpeg", "image/png"].includes(_.toLower(file.type));
            const isLt3M = file.size / 1024 / 1024 < 3;

            if (!isLt3M) {
                toastr.error("Photo file size can not exceed 3MB! Try using <a style='color: yellow' href='https://tinypng.com/' target='_blank'>TinyPNG</a> to compress your photos");
            }

            if (!isImg) {
                toastr.error("Only jpg and png photos allowed!");
            }

            return isLt3M && isImg;

        },

        handleChange (file, fileList) {

            if (file.response && file.response.model_id === this.modelId) {
                this.photos.unshift(file.response);
            }

        },

        removePhoto (file) {

            if (file === undefined || (file.id === undefined && file.response === undefined)) {
                return true;
            }

            let mediaId = file.id !== undefined ? file.id : file.response.id;
            let self = this;

            return new Promise((resolve, reject) => {

                swal({
                    title: "Delete photo",
                    text: "Are you sure you want to delete this photo (" + file.name + ") ?",
                    showCancelButton: true
                }).then((result) => {
                    if (result.value) {

                        axios.post("/" + this.modelType + "/photos/" + mediaId + "/delete", {_method: "DELETE"})
                        .then(response => {
                            self.photos.splice(this.photos.indexOf(file), 1);
                            if (this.photos.length === 0) {
                                Bus.$emit("last-photo-removed", file.url);
                            }
                            if (this.modelType === "tickets") {
                                Bus.$emit("issues-updated");
                            }
                            resolve(response.data);
                        })
                        .catch(errors => {
                            toastr.error(errors.response.data);
                            reject(errors.response);
                        });

                    } else {
                        return reject();
                    }
                });

            });

        },

        viewPhoto (file) {
            Bus.$emit("view-photo", file.url);
            this.selectedImageIndex = this.photos.indexOf(file);
            this.toggleImageViewer();
        },

        closePhotosPanel () {
            this.$emit("close-photos-panel");
        },

        dragOver (event) {
            this.$refs.photolistDropzone.setOption("url", this.dropzoneUrl);
            // Add some visual fluff to show the user can drop its files
            if (!event.currentTarget.classList.contains("border-gray-400")) {
                event.currentTarget.classList.remove("border-white");
                event.currentTarget.classList.add("bg-blue-50", "border-gray-400");
            }
        },

        dragLeave (event) {
            // Clean up
            event.currentTarget.classList.remove("border-gray-400", "bg-blue-50");
            event.currentTarget.classList.add("border-white");
        },

        fileDropped (event) {
            this.dragLeave(event);
            this.scrollToEnd();
        },

        fileUploaded (file, response) {
            toastr.success(this.fileName + " has successfully uploaded");
            this.fetchPhotos();
        },

        scrollToEnd () {
            let container = this.$el.querySelector("#container");
            container.scrollTop = container.scrollHeight;
        },
    }
};
</script>

<style>
.custom-photo-list {
    display: block;
    max-height: 100vh;
}

.copied-photo {
    position: absolute;
    bottom: 0;
    right: 10px;
    color: #fff;
    font-size: 3em;
}

</style>
